import { render, staticRenderFns } from "./AuthedVideo.vue?vue&type=template&id=7f0a0dd6&scoped=true"
import script from "./AuthedVideo.vue?vue&type=script&lang=js"
export * from "./AuthedVideo.vue?vue&type=script&lang=js"
import style0 from "./AuthedVideo.vue?vue&type=style&index=0&id=7f0a0dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a0dd6",
  null
  
)

export default component.exports